module.exports = __webpack_public_path__ + "b435248f782b0ebe05c4442cc1862580.png";